import type { KeyboardEventHandler } from "react";
import { SearchFilter } from "./searchFilter";

type Props = {
	onKeyDown: KeyboardEventHandler<HTMLDivElement> | undefined;
};

export const Filters = ({ onKeyDown }: Props) => {
	return <SearchFilter onKeyDown={onKeyDown} />;
};
